// extracted by mini-css-extract-plugin
export default {"tab-wrapper":"a89cc3"};